// TEMPORARY FIX: Always use production URL for now
const API_BASE_URL = 'https://fitcoachai.onrender.com';

// Debug logging
console.log('🔧 CONFIG DEBUG START 🔧');
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('Final API_BASE_URL:', API_BASE_URL);
console.log('🔧 CONFIG DEBUG END 🔧');

export default API_BASE_URL;
